export default {
  edit: {
    title: 'Editer son profil',
    subTitle: 'Formulaire d\'édition',
    editInformation: 'Modifier mes informations',
    sexOptionLabel: {
      male: 'Homme',
      female: 'Femme',
      unknown: 'Non renseigné'
    },
    notifyMessage: 'Modification effectuée'
  },
  changePassword: {
    title: 'Modifier mon mot de passe',
    subTitle: 'Saissisez votre ancien mot de passe. Ensuite entrez deux fois votre nouveau mot de passe.',
    lastPassword: 'Entrez l\'ancien mot de passe',
    newPassword: 'Entrez le nouveau mot de passe',
    notifyMessage: 'Modification effectuée',
    notifyMessageError: 'Modification non effectuée, vérifiez votre mot de passe'

  }
}
